module.exports = __webpack_public_path__ + "static/img/sev-eye-severance.f43deb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/sev-eye-severance.jpg
// module id = rHaR
// module chunks = 0